<template>
  <div class="progress-bar-wrapper">
    <div class="left-value">0</div>
    <div class="progress-bar-container" :style="{ backgroundColor: containerBgColor }" ref="progress-bar" @mousedown.prevent="startDragging" @touchstart.prevent="startDragging">
      <div class="progress-bar" :style="{ width: input + '%', backgroundColor: bgColor }"></div>
      <div class="progress-handle" :style="{ left: input + '%' }" @mousedown.stop.prevent="startDragging" @touchstart.stop.prevent="startDragging">{{progressText}}</div>
    </div>
    <div class="right-value">100</div>
  </div>
</template>

<script>
export default {
  name: 'draggableProgressBar',
  props: {
    value: {
      type: Number,
      default: 50
    },
    bgColor: {
      type: String,
      default: 'rgba(79, 82, 255, 1)'
    },
    containerBgColor: {
      type: String,
      default: 'rgba(238, 238, 238, 1)'
    }
  },
  data() {
    return {
      input: 0,
      isDragging: false,
    };
  },
  created() {
    this.input = this.value
  },
  watch: {
    value(newVal, oldVal) {
      if(newVal !== oldVal) {
        this.input = newVal
      }
    }
  },
  computed:{
    progressText () {
      return Math.round(this.input) || 0
    }
  },
  methods: {
    startDragging(event) {
      this.isDragging = true;
      this.updateProgress(event);
      document.addEventListener('mousemove', this.onMouseMove);
      document.addEventListener('mouseup', this.stopDragging);
      document.addEventListener('touchmove', this.onTouchMove);
      document.addEventListener('touchend', this.stopDragging);
    },
    onMouseMove(event) {
      if (this.isDragging) {
        this.updateProgress(event);
      }
    },
    onTouchMove(event) {
      if (this.isDragging) {
        const touch = event.touches[0];
        this.updateProgress(touch);
      }
    },
    updateProgress(event) {
      try {
        const container = this.$refs["progress-bar"];
        const rect = container?.getBoundingClientRect();
        let clientX = event.clientX || event.pageX; // 支持触摸和鼠标事件
        if (!clientX) return
        let newProgress = ((clientX - rect.left) / rect.width) * 100;
        newProgress = Math.max(0, Math.min(100, newProgress));
        this.input = newProgress
        this.$emit("input", this.input)
      } catch (error) {
        console.log(error)
      }
    
    },
    stopDragging() {
      this.isDragging = false;
      document.removeEventListener('mousemove', this.onMouseMove);
      document.removeEventListener('mouseup', this.stopDragging);
      document.removeEventListener('touchmove', this.onTouchMove);
      document.removeEventListener('touchend', this.stopDragging);
    },
  },
};
</script>

<style scoped>
.left-value {
  margin-right: 10px;
}
.right-value {
  margin-left: 10px;
}
.progress-bar-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
}
.progress-bar-container {
  flex: 1;
  position: relative;
  width: 100%;
  height: 8px;
  border-radius: 64px;
  user-select: none;
}
.progress-bar {
  height: 100%;
  border-radius: 64px;
}
.progress-handle {
  position: absolute;
  top: 50%;
  width: 12px;
  height: 12px;
  cursor: pointer;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 2px 4px  rgba(0, 0, 0, 0.25);
  font-size: 5px;
  font-weight: 400;
  line-height: 12px;
  color: rgba(201, 193, 193, 1);
  text-align: center;
}
</style>
